import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight, FiAward, FiChevronLeft, FiChevronRight,
  FiPhone, FiMail, FiCheckCircle, FiPlus, FiMinus, FiStar, FiX,
} from "react-icons/fi";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { useInView } from "../components/useInView";
import slide1 from "../assets/images/slideshow/slideshow-1.png";
import slide2 from "../assets/images/slideshow/slideshow-2.png";
import slide3 from "../assets/images/slideshow/slideshow-3.png";
import slide4 from "../assets/images/slideshow/slideshow-4.png";
import slide5 from "../assets/images/slideshow/slideshow-5.png";

/* ── about / why image ── */
import aboutImgLocal from "../assets/images/ppt_media_image11.jpg";
import whyChooseImg  from "../assets/images/ppt_media_image8.jpg";

/* ── service card images ── */
import svcImg1 from "../assets/images/services/scaffording.jpg";
import svcImg2 from "../assets/images/services/columns.jpg";
import svcImg3 from "../assets/images/services/retaining-wall.jpg";
import svcImg4 from "../assets/images/services/suspended-slab.jpg";
import svcImg5 from "../assets/images/services/ring-beam.jpg";
import svcImg6 from "../assets/images/services/transport.jpg";
import svcImg7 from "../assets/images/services/temporary-work-design.jpg";
import svcImg8 from "../assets/images/services/pr-engineer-services.jpeg";

/* ── service SVG icons ── */
import svcIcon1 from "../assets/images/services/services_01.svg";
import svcIcon2 from "../assets/images/services/services_02.svg";
import svcIcon3 from "../assets/images/services/services_03.svg";
import svcIcon4 from "../assets/images/services/services_04.svg";
import svcIcon5 from "../assets/images/services/services_05.svg";
import svcIcon6 from "../assets/images/services/services_06.svg";
import svcIcon7 from "../assets/images/services/services_01.svg";
import svcIcon8 from "../assets/images/services/services_02.svg";

/* ── portfolio images ── */
import g4_01        from "../assets/images/portfolio/g4-mining_01.jpg";
import ferrobank_01 from "../assets/images/portfolio/ferrobank_01.jpg";
import ferrobank_03 from "../assets/images/portfolio/ferrobank_03.jpg";
import degrit_01    from "../assets/images/portfolio/ferrobank-de-grit-01.jpg";
import dannhauser_01 from "../assets/images/portfolio/dannhauser_01.jpg";
import kuruman_01   from "../assets/images/portfolio/kuruman_01.jpg";
import aerosud_01   from "../assets/images/portfolio/aerosud_01.jpg";
import steelpoort_01 from "../assets/images/portfolio/steelpoort_01.jpg";
import steelpoort_02 from "../assets/images/portfolio/steelpoort_02.jpg";
import steelpoort_05 from "../assets/images/portfolio/steelpoort_05.jpg";
import h5Middle     from "../assets/images/portfolio/h5-3.webp";

/* ── blog images ── */
import blogImg1 from "../assets/images/portfolio/ppt_media_image12.jpg";
import blogImg2 from "../assets/images/portfolio/ppt_media_image22.jpg";
import blogImg3 from "../assets/images/portfolio/ppt_media_image33.jpg";

/* ── partner logos ── */
import partner_1  from "../assets/images/partners/partner_01.jpg";
import partner_2  from "../assets/images/partners/partner_02.jpg";
import partner_3  from "../assets/images/partners/partner_03.jpg";
import partner_4  from "../assets/images/partners/partner_04.jpg";
import partner_5  from "../assets/images/partners/partner_05.jpg";
import partner_6  from "../assets/images/partners/partner_06.jpg";
import partner_8  from "../assets/images/partners/partner_08.jpg";
import partner_9  from "../assets/images/partners/partner_09.jpg";
import partner_10 from "../assets/images/partners/partner_10.jpg";
import partner_11 from "../assets/images/partners/partner_11.jpg";
import partner_12 from "../assets/images/partners/partner_12.jpg";
import partner_13 from "../assets/images/partners/partner_13.jpg";
import partner_14 from "../assets/images/partners/partner_14.jpg";
import partner_15 from "../assets/images/partners/partner_15.png";
import partner_16 from "../assets/images/partners/partner_16.jpg";
import partner_17 from "../assets/images/partners/partner_17.jpg";

import "./Home.css";

const partnerLogos = [
  partner_1, partner_2, partner_3, partner_4, partner_5,
  partner_6, partner_8, partner_9, partner_10,
  partner_11, partner_12, partner_13, partner_14, partner_15,
  partner_16, partner_17,
];

/* ── SLIDESHOW DATA ── */
const slides = [
  {
    id: 1,
    image: slide1,
    label: "Quality & Value",
    heading: ["The Best Supply &", "Erect Technical", "Solution"],
    sub: "A quality product and exceptional service at the lowest available price.",
    cta: { label: "View Our Projects", to: "/projects" },
    infoItems: [
      { num: "01", text: "Premium Formwork Supply" },
      { num: "02", text: "Cost-Effective Solutions" },
    ],
  },
  {
    id: 2,
    image: slide2,
    label: "Logistics & Flexibility",
    heading: ["Availability,", "Flexible Delivery", "& Storage"],
    sub: "Our customers benefit from flexible delivery and improved equipment storage solutions.",
    cta: { label: "Our Services", to: "/services" },
    infoItems: [
      { num: "01", text: "Flexible Delivery Options" },
      { num: "02", text: "Equipment Storage Solutions" },
    ],
  },
  {
    id: 3,
    image: slide3,
    label: "African Vision",
    heading: ["Committed to", "Our Country's", "Potential"],
    sub: "Deeply committed to the potential hidden in our continent and our country.",
    cta: { label: "Our Story", to: "/about" },
    infoItems: [
      { num: "01", text: "Pan-African Commitment" },
      { num: "02", text: "Community Development" },
    ],
  },
  {
    id: 4,
    image: slide4,
    label: "Infrastructure Excellence",
    heading: ["Delivering", "World-Class", "Infrastructure"],
    sub: "Engineering solutions built for communities across South Africa.",
    cta: { label: "Our Services", to: "/services" },
    infoItems: [
      { num: "01", text: "World-Class Engineering" },
      { num: "02", text: "Civil Infrastructure" },
    ],
  },
  {
    id: 5,
    image: slide5,
    label: "Community Impact",
    heading: ["Building a", "Better South", "Africa"],
    sub: "18 years of commitment to local employment and meaningful social impact.",
    cta: { label: "Get a Quote", to: "/contact" },
    infoItems: [
      { num: "01", text: "Local Employment" },
      { num: "02", text: "Social Impact Projects" },
    ],
  },
];

/* ── disable right-click / drag ── */
function useNoContextMenu() {
  useEffect(() => {
    const handler = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handler);
    return () => document.removeEventListener("contextmenu", handler);
  }, []);
}

/* ── RESPONSIVE BREAKPOINT HOOK ── */
function useBreakpoint() {
  const getBreakpoint = () => {
    if (typeof window === "undefined") return "desktop";
    const w = window.innerWidth;
    if (w <= 768) return "mobile";
    if (w <= 1024) return "tablet";
    return "desktop";
  };
  const [bp, setBp] = useState(getBreakpoint);
  useEffect(() => {
    const handler = () => setBp(getBreakpoint());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return bp;
}

/* ── ANIMATED COUNTER ── */
function AnimatedCounter({ value, suffix, decimals = 0, delay = 0 }) {
  const [ref, inView] = useInView();
  const countRef = useRef(null);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / 1800, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      if (countRef.current)
        countRef.current.textContent = decimals
          ? (eased * value).toFixed(decimals)
          : Math.floor(eased * value);
      if (p < 1) requestAnimationFrame(step);
    };
    setTimeout(() => requestAnimationFrame(step), delay);
  }, [inView, value, decimals, delay]);
  return (
    <span ref={ref}>
      <span ref={countRef}>0</span>{suffix}
    </span>
  );
}

/* ── YOUTUBE EMBED MODAL ── */
function VideoModal({ isOpen, onClose }) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <div className="video-modal" onClick={onClose}>
      <div className="video-modal__box" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal__close" onClick={onClose} aria-label="Close video">
          <FiX size={22} />
        </button>
        <div className="video-modal__embed">
          <iframe
            src="https://www.youtube.com/embed/9oVDA83yxWI?autoplay=1"
            title="Bakwena Kit"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}

/* ── ACCORDION ITEM ── */
function AccordionItem({ title, body, isOpen, onToggle, index }) {
  return (
    <div className={`why-accordion__item${isOpen ? " why-accordion__item--open" : ""}`}>
      <button className="why-accordion__trigger" onClick={onToggle} aria-expanded={isOpen}>
        <div className="why-accordion__trigger-left">
          <span className="why-accordion__num">{String(index + 1).padStart(2, "0")}</span>
          <span className="why-accordion__title">{title}</span>
        </div>
        <span className="why-accordion__icon">
          {isOpen ? <FiMinus size={16} /> : <FiPlus size={16} />}
        </span>
      </button>
      <div className="why-accordion__body-wrap">
        <div className="why-accordion__body">
          <p>{body}</p>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════
   HOME
   ═══════════════════════════════════════════ */
export default function Home() {

  /* disable right-click */
  useNoContextMenu();

  /* responsive breakpoint */
  const breakpoint = useBreakpoint();

  /* slideshow */
  const [current, setCurrent]     = useState(0);
  const [prev, setPrev]           = useState(null);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState("next");
  const timerRef = useRef(null);

  /* video modal */
  const [videoOpen, setVideoOpen] = useState(false);

  /* services carousel */
  const [svcIndex, setSvcIndex] = useState(0);

  /* what-we-offer card slider */
  const [svcTabIndex, setSvcTabIndex] = useState(0);

  /* accordion */
  const [openAccordion, setOpenAccordion] = useState(0);

  /* section observers */
  const [aboutRef,   aboutInView]   = useInView();
  const [offerRef,   offerInView]   = useInView();
  const [svcRef,     svcInView]     = useInView();
  const [whyRef,     whyInView]     = useInView();
  const [portRef,    portInView]    = useInView();
  const [testiRef,   testiInView]   = useInView();
  const [blogRef,    blogInView]    = useInView();

  /* slideshow logic */
  const goTo = useCallback((idx, dir = "next") => {
    if (animating || idx === current) return;
    setDirection(dir); setPrev(current); setAnimating(true); setCurrent(idx);
    setTimeout(() => { setPrev(null); setAnimating(false); }, 900);
  }, [animating, current]);

  const next  = useCallback(() => goTo((current + 1) % slides.length, "next"), [current, goTo]);
  const prev_ = useCallback(() => goTo((current - 1 + slides.length) % slides.length, "prev"), [current, goTo]);

  useEffect(() => {
    timerRef.current = setInterval(next, 6000);
    return () => clearInterval(timerRef.current);
  }, [next]);

  const resetTimer = () => { clearInterval(timerRef.current); timerRef.current = setInterval(next, 6000); };
  const handleNext = () => { next();  resetTimer(); };
  const handlePrev = () => { prev_(); resetTimer(); };
  const handleDot  = (i) => { goTo(i, i > current ? "next" : "prev"); resetTimer(); };

  /* what-we-offer cards */
  const offerCards = [
    { img: ferrobank_03,  title: "Our Mission",  sub: "Service Excellence",  desc: "To continually strive towards innovative solutions, economical services, efficient project execution, and becoming the preferred temporary works service provider." },
    { img: degrit_01,     title: "Our Vision",   sub: "Industry Leadership", desc: "To improve the standard of support, engineering input and construction experience in both the civil, mining and building environment." },
    { img: g4_01,         title: "Our Aim",      sub: "Industry Impact",     desc: "We aim to be celebrated for contributing valuable insight and unrivalled expertise to the South African construction industry." },
    { img: steelpoort_02, title: "Philosophy",   sub: "Our Approach",        desc: "We build with purpose. Every project is guided by responsibility, transparency, and respect for both people and the environment." },
    { img: steelpoort_05, title: "Core Values",  sub: "What Drives Us",      desc: "Customer focus, integrity, and continuous improvement — doing what is right and delivering on our commitments every time." },
  ];
  const SVC_TAB_VISIBLE = 2;
  const svcTabMax = offerCards.length - SVC_TAB_VISIBLE;

  /* services list */
  const svcList = [
    { img: svcImg1, icon: svcIcon1, title: "Formwork and Scaffolding",  desc: "Formwork and scaffolding are temporary construction structures that act as a mold to support wet concrete and elevated working platforms." },
    { img: svcImg2, icon: svcIcon2, title: "Columns",                   desc: "Columns are vertical structural members primarily designed to support compressive loads, safely transferring them to foundations below." },
    { img: svcImg3, icon: svcIcon3, title: "Retaining Walls",           desc: "Retaining Walls are engineered structures designed to hold back soil laterally, preventing erosion and supporting uneven terrain." },
    { img: svcImg4, icon: svcIcon4, title: "Suspended Slab",            desc: "A suspended slab is a reinforced concrete floor or roof that is elevated above the ground and supported by beams or walls." },
    { img: svcImg5, icon: svcIcon5, title: "Ring Beam",                 desc: "A ring beam is a continuous, reinforced concrete beam that runs horizontally along the top of walls to distribute loads uniformly." },
    { img: svcImg6, icon: svcIcon6, title: "Transport",                 desc: "Encompasses the planning, design, and construction of infrastructure networks that facilitate the safe and efficient movement of people." },
    { img: svcImg7, icon: svcIcon7, title: "Temporary Work Design",     desc: "Critical for ensuring structural stability and worker safety, bearing loads such as self-weight of formwork, wet concrete and construction loads." },
    { img: svcImg8, icon: svcIcon8, title: "PR Engineer Services",      desc: "Encompass the full lifecycle of infrastructure development. These registered experts provide oversight, certification and professional sign-off." },
  ];

  // ── FIX: derive visible card count and max index from current breakpoint ──
  const svcVisible = breakpoint === "mobile" ? 1 : breakpoint === "tablet" ? 2 : 3;
  const svcMaxIndex = svcList.length - svcVisible;

  // Clamp svcIndex whenever breakpoint changes so we never sit past the new max
  useEffect(() => {
    setSvcIndex(i => Math.min(i, svcList.length - svcVisible));
  }, [svcVisible, svcList.length]);

  const handleSvcPrev = () => setSvcIndex(i => Math.max(0, i - 1));
  const handleSvcNext = () => setSvcIndex(i => Math.min(svcMaxIndex, i + 1));

  /* why choose us accordion */
  const whyItems = [
    { title: "Safety First",          body: "Bakwena Kit works to HSAS18001 certification to always guarantee high quality delivery and safe operations." },
    { title: "Commitment to Quality", body: "Bakwena Kit Formwork and Scaffolding is compliant to the International Organisation for Standards ISO9001/2008." },
    { title: "Early Involvement",     body: "Our experienced engineering design staff will translate your requirements into cost effective formwork & shoring design solutions, tailored to the exact needs of the project." },
    { title: "Tailored Solutions",    body: "By combining our designers' knowledge and experience of the capabilities of our equipment range, the systems we design are innovative, practical and cost effective." },
    { title: "Building With Trust",   body: "Doing business with Bakwena Kit, ensures you access to an entire team of highly trained individuals, whose main objective is to ensure you achieve a successful outcome." },
    { title: "B-BBEE Level 1",        body: "Committed to economic transformation, skills development, and supporting local SMMEs." },
  ];

  /* portfolio */
  const [activeFilter, setActiveFilter] = useState("All");
  const filters = ["All", "Mining", "Water", "Civils", "Industrial", "Structural", "Infrastructure"];
  const portImages = [
    { src: g4_01,         title: "G4 Mining & Civils",        cats: ["Mining"],         desc: "Matla Coal Mine — formwork and temporary works for underground mining civils." },
    { src: ferrobank_01,  title: "Reservoir Specialized",      cats: ["Water"],          desc: "Specialized water structures and reservoir construction for municipal water supply." },
    { src: dannhauser_01, title: "Dannhauser Reservoir",       cats: ["Water"],          desc: "3.5 ML capacity reservoir serving the Dannhauser community." },
    { src: kuruman_01,    title: "Kuruman Circulation Tanks",  cats: ["Civils"],         desc: "Civils infrastructure — circulation tank construction for Kuruman water treatment." },
    { src: aerosud_01,    title: "Aerosud Space",              cats: ["Industrial"],     desc: "Industrial construction — precision formwork for Aerosud's aerospace facility." },
    { src: steelpoort_01, title: "Steelpoort Bridge",          cats: ["Infrastructure"], desc: "R555 road infrastructure — bridge construction in Limpopo province." },
  ];
  const filteredPort = activeFilter === "All" ? portImages : portImages.filter(p => p.cats.includes(activeFilter));

  /* testimonials */
  const testis = [
    { name: "Sipho Mthembu",   role: "Director, Mogalakwena Combined Reservoir", body: "Bakwena Kit delivered our bulk water project three weeks ahead of schedule. Their on-site supervision and communication were exceptional. We will continue to use them as a preferred contractor." },
    { name: "Yvonne Plaatjes", role: "CFO, Petrus Steyn Reservoir",         body: "We have worked with many contractors but Bakwena Kit stands apart. Their safety record is flawless, their quality is consistent, and they are true partners in every sense of the word." },
    { name: "Refiloe Dlamini", role: "CEO, Dikgalaope & Vredefort",  body: "The water reservoir project was complex and politically sensitive. Bakwena Kit navigated every challenge with professionalism and delivered results the community is genuinely proud of." },
  ];

  /* blog */
  const blogPosts = [
    { img: blogImg1, day: "12", month: "Mar", year: "2025", cat: "Infrastructure", title: "How Infrastructure Investment Drives Local Economic Growth",    desc: "A look at how sustained public works investment creates lasting employment, supply-chain development, and GDP uplift." },
    { img: blogImg2, day: "28", month: "Feb", year: "2025", cat: "Industry",       title: "We aim to elevate the standard of engineering expertise", desc: "By positioning Bakwena Kit as a leading provider of temporary works solutions in both civil and building sectors." },
    { img: blogImg3, day: "15", month: "Jan", year: "2025", cat: "Transformation",  title: "B-BBEE Level 1: Our Ongoing Commitment to Transformation",     desc: "How Bakwena Kit actively structures its procurement and hiring to meet and exceed Level 1 targets every year." },
  ];

  const ctaBg = "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?w=1400&q=80";

  return (
    <main className="home">

      {/* ═══════════ VIDEO MODAL ═══════════ */}
      <VideoModal isOpen={videoOpen} onClose={() => setVideoOpen(false)} />

      {/* ═══════════ HERO ═══════════ */}
      <section className="hero">
        {slides.map((slide, i) => {
          const isActive = i === current, isPrev = i === prev;
          let cls = "hero__slide";
          if (isActive) cls += ` hero__slide--active hero__slide--enter-${direction}`;
          if (isPrev)   cls += ` hero__slide--exit hero__slide--exit-${direction}`;
          return (
            <div key={slide.id} className={cls}>
              <div className="hero__slide-bg" style={{ backgroundImage: `url(${slide.image})` }} />
              <div className="hero__dark-overlay" />
            </div>
          );
        })}

        {/* Social sidebar */}
        <div className="hero__social">
          <span className="hero__social-label">Follow Us</span>
          <a href="#" aria-label="Facebook"><FaFacebookF size={13} /></a>
          <a href="#" aria-label="Twitter"><FaTwitter size={13} /></a>
          <a href="#" aria-label="LinkedIn"><FaLinkedinIn size={13} /></a>
          <a href="#" aria-label="YouTube"><FaYoutube size={13} /></a>
        </div>

        {/* Main text layers */}
        <div className="container hero__content">
          {slides.map((slide, i) => {
            const isActive = i === current;
            return (
              <div
                key={slide.id}
                className={`hero__text-layer${isActive ? " hero__text-layer--active" : ""}`}
                aria-hidden={!isActive}
              >
                <div className="hero__badge"><FiAward size={12} />{slide.label} — BAKWENA KIT</div>
                <h1 className="hero__title">
                  {slide.heading.map((line, j) => (
                    <span
                      key={j}
                      className={`hero__title-line${j === 1 ? " hero__title-line--accent" : ""}`}
                      style={{ transitionDelay: `${0.1 + j * 0.1}s` }}
                    >
                      {line}
                    </span>
                  ))}
                </h1>
                <p className="hero__desc">{slide.sub}</p>
                <div className="hero__actions">
                  <Link to={slide.cta.to} className="btn-primary">{slide.cta.label} <FiArrowRight /></Link>
                  <Link to="/contact" className="btn-hero-outline">Get a Quote</Link>
                </div>
              </div>
            );
          })}
        </div>

        {/* Info box */}
        <div className="hero__info-box">
          {slides.map((slide, i) => (
            <div
              key={slide.id}
              className={`hero__info-items${i === current ? " hero__info-items--active" : ""}`}
              aria-hidden={i !== current}
            >
              {slide.infoItems.map((item, j) => (
                <div key={j} className={`hero__info-item${j === 0 ? " hero__info-item--active" : ""}`}>
                  <span className="hero__info-num">{item.num}</span>
                  <span className="hero__info-text">{item.text}</span>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="hero__bottom-bar">
          <div className="hero__counter">
            <span className="hero__counter-current">{String(current + 1).padStart(2, "0")}</span>
            <span className="hero__counter-sep" />
            <span className="hero__counter-total">{String(slides.length).padStart(2, "0")}</span>
          </div>
          <div className="hero__dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`hero__dot${i === current ? " hero__dot--active" : ""}`}
                onClick={() => handleDot(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
          <div className="hero__arrows">
            <button className="hero__arrow" onClick={handlePrev} aria-label="Prev"><FiChevronLeft size={20} /></button>
            <button className="hero__arrow" onClick={handleNext} aria-label="Next"><FiChevronRight size={20} /></button>
          </div>
        </div>

        <div className="hero__progress"><div key={current} className="hero__progress-bar" /></div>
      </section>

      {/* ═══════════ ABOUT SPLIT ═══════════ */}
      <section className="home-about" ref={aboutRef}>
        <div className="container">
          <div className="home-about__inner">
            <div className="home-about__img-col">
              <img src={aboutImgLocal} alt="Bakwena Kit infrastructure" loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} />
              <div className="home-about__exp-badge">
                <span className="home-about__exp-num">140<sup>+</sup></span>
                <span className="home-about__exp-text">Projects<br />Completed</span>
              </div>
            </div>
            <div className={`home-about__text-col fade-in ${aboutInView ? "visible" : ""}`}>
              <p className="section-label">About Bakwena Kit</p>
              <h2 className="section-title">
                Infrastructure is<br /><span>Essential to South Africa's Growth.</span>
              </h2>
              <p className="home-about__lead">
                Bakwena Kit (Pty) Ltd is a proudly South African formwork and scaffolding company. Our mission is to elevate the standard of support services and engineering expertise, positioning Bakwena Kit as a leading provider of temporary works solutions in both civil and building sectors.
              </p>
              <div className="home-about__bullets">
                {[
                  "Skilled, passionate people committed to quality and long-term success.",
                  "We listen, adapt, and deliver tailored solutions to your needs.",
                  "Trusted through consistent performance and cross-sector project success.",
                ].map((b, i) => (
                  <div key={i} className="home-about__bullet">
                    <FiCheckCircle size={16} className="home-about__bullet-icon" />
                    <span>{b}</span>
                  </div>
                ))}
              </div>
              <Link to="/about" className="btn-primary">More About Us <FiArrowRight /></Link>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════ WHAT WE OFFER — GRAVITON STYLE ═══════════ */}
      <section className="home-offer" ref={offerRef}>

        {/* LEFT COLUMN — sliding offer cards */}
        <div className="home-offer__left">
          <div className="home-offer__left-head">
            <p className="home-offer__section-label">OUR COMMITMENTS</p>
            <div className="home-offer__nav">
              <button
                className="home-offer__nav-btn"
                onClick={() => setSvcTabIndex(i => Math.max(0, i - 1))}
                disabled={svcTabIndex === 0}
                aria-label="Previous"
              >
                <FiChevronLeft size={18} />
              </button>
              <button
                className="home-offer__nav-btn"
                onClick={() => setSvcTabIndex(i => Math.min(svcTabMax, i + 1))}
                disabled={svcTabIndex >= svcTabMax}
                aria-label="Next"
              >
                <FiChevronRight size={18} />
              </button>
            </div>
          </div>

          <div className="home-offer__cards-viewport">
            <div
              className="home-offer__cards-track"
              style={{ transform: `translateX(calc(-${svcTabIndex} * 50%))` }}
            >
              {offerCards.map((card, i) => (
                <div key={i} className="home-offer__card">
                  <div className="home-offer__card-img">
                    <img src={card.img} alt={card.title} loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                  </div>
                  <div className="home-offer__card-body">
                    <span className="home-offer__card-sub">{card.sub}</span>
                    <h3 className="home-offer__card-title">{card.title}</h3>
                    <p className="home-offer__card-desc">{card.desc}</p>
                    <Link to="/about" className="home-offer__card-link">
                      VIEW MORE <FiArrowRight size={13} />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* MIDDLE COLUMN — orange hero + image */}
        <div className="home-offer__mid">
          <div className="home-offer__mid-text">
            <h2 className="home-offer__mid-heading">
              The best supply &amp; erect, technical solution
            </h2>
            <p className="home-offer__mid-sub">
              A quality product and exceptional service at the lowest available price.
            </p>
            <Link to="/contact" className="home-offer__mid-btn" aria-label="Get a Quote">
              <FiArrowRight size={20} />
            </Link>
          </div>
          <div className="home-offer__mid-img">
            <img src={h5Middle} alt="Bakwena Kit construction" loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
          </div>
        </div>

        {/* RIGHT COLUMN — Why Choose Us */}
        <div className="home-offer__right">
          <p className="home-offer__section-label home-offer__section-label--light">WHY CHOOSE US</p>
          <p className="home-offer__right-desc">
            Developed in close collaboration with our partners and clients, Bakwena Kit combines industry knowledge, decades of experience, and adaptability to deliver excellence.
          </p>
          <ul className="home-offer__checklist">
            {[
              "Safety First — HSAS18001 Certified",
              "ISO 9001 Quality Commitment",
              "Early Engineering Involvement",
              "Tailored Formwork Solutions",
              "B-BBEE Level 1 Contributor",
            ].map((item, i) => (
              <li key={i} className="home-offer__check-item">
                <span className="home-offer__check-icon" aria-hidden="true">
                  <FiCheckCircle size={16} />
                </span>
                {item}
              </li>
            ))}
          </ul>
          <Link to="/about" className="home-offer__view-more">
            VIEW MORE <FiArrowRight size={13} />
          </Link>
        </div>

      </section>

      {/* ═══════════ PARTNER LOGOS MARQUEE ═══════════ */}
      <section className="home-partners">
        <div className="home-partners__label-bar">
          <div className="container">
            <span className="home-partners__heading">PROJECT REFERENCES &amp; CLIENTS</span>
          </div>
        </div>
        <div className="home-partners__marquee">
          <div className="home-partners__track">
            {[...partnerLogos, ...partnerLogos].map((src, i) => (
              <div key={i} className="home-partners__logo">
                <img
                  src={src}
                  alt={`Partner ${(i % partnerLogos.length) + 1}`}
                  loading="lazy"
                  draggable="false"
                  onDragStart={(e) => e.preventDefault()}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════ WHY CHOOSE US — ACCORDION ═══════════ */}
      <section className="home-why" ref={whyRef}>
        <div className="container">
          <div className="home-why__inner">
            <div className="home-why__img-col">
              <img src={whyChooseImg} alt="Bakwena Kit technical design services" loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
            </div>
            <div className={`home-why__content-col fade-in ${whyInView ? "visible" : ""}`}>
              <p className="section-label">Why Choose Us</p>
              <h2 className="section-title">
                TECHNICAL DESIGN<br /><span>SERVICES</span>
              </h2>
              <p className="home-why__lead">
                We are deeply committed to the potential hidden on our continent and more particularly in our country. We aim to elevate the standard of support services and engineering expertise, positioning Bakwena Kit as a leading provider of temporary works solutions in both civil and building sectors.
              </p>
              <div className="why-accordion">
                {whyItems.map((item, i) => (
                  <AccordionItem
                    key={i}
                    index={i}
                    title={item.title}
                    body={item.body}
                    isOpen={openAccordion === i}
                    onToggle={() => setOpenAccordion(openAccordion === i ? null : i)}
                  />
                ))}
              </div>
              <Link to="/about" className="btn-primary" style={{ marginTop: "28px", display: "inline-flex" }}>
                Our Core Values <FiArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════ SERVICES CAROUSEL ═══════════ */}
      <section className="home-services" ref={svcRef}>
        <div className="container">
          <div className={`home-services__header fade-in ${svcInView ? "visible" : ""}`}>
            <div>
              <p className="section-label">Our Services</p>
              <h2 className="section-title">What We Build,<br />We Build <span>Right</span></h2>
            </div>
            <div className="home-services__header-right">
              <p>From formwork and scaffolding to civil infrastructure — our expert team delivers quality construction solutions tailored to your vision.</p>
              <Link to="/services" className="btn-outline">View All Services <FiArrowRight /></Link>
            </div>
          </div>

          <div className="home-services__carousel-wrap">
            <div className="home-services__carousel-side home-services__carousel-side--left">
              <div className="home-services__carousel-accent-line" />
              <button
                className="home-services__carousel-arrow home-services__carousel-arrow--prev"
                onClick={handleSvcPrev}
                disabled={svcIndex === 0}
                aria-label="Previous services"
              >
                <FiChevronLeft size={22} />
              </button>
              <div className="home-services__carousel-accent-line" />
            </div>

            <div className="home-services__carousel-viewport">
              <div
                className="home-services__carousel-track"
                style={{ transform: `translateX(calc(-${svcIndex} * (100% / ${svcVisible})))` }}
              >
                {svcList.map((svc, i) => (
                  <div
                    key={i}
                    className={`svc-card fade-in ${svcInView ? "visible" : ""}`}
                    style={{ transitionDelay: `${i * 0.08}s` }}
                  >
                    <div className="svc-card__img-wrap">
                      <img src={svc.img} alt={svc.title} loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                      <div className="svc-card__img-overlay" />
                    </div>
                    <div className="svc-card__icon-wrap">
                      <img src={svc.icon} alt={svc.title} className="svc-card__icon-img" />
                    </div>
                    <div className="svc-card__body">
                      <div className="svc-card__top">
                        <span className="svc-card__num">0{i + 1}</span>
                      </div>
                      <h3 className="svc-card__title">{svc.title}</h3>
                      <p className="svc-card__desc">{svc.desc}</p>
                      <Link to="/services" className="svc-card__link">Read More <FiArrowRight size={14} /></Link>
                    </div>
                    <div className="svc-card__accent-line" />
                  </div>
                ))}
              </div>
            </div>

            <div className="home-services__carousel-side home-services__carousel-side--right">
              <div className="home-services__carousel-accent-line" />
              <button
                className="home-services__carousel-arrow home-services__carousel-arrow--next"
                onClick={handleSvcNext}
                disabled={svcIndex >= svcMaxIndex}
                aria-label="Next services"
              >
                <FiChevronRight size={22} />
              </button>
              <div className="home-services__carousel-accent-line" />
            </div>
          </div>

          <div className="home-services__carousel-dots">
            {Array.from({ length: svcMaxIndex + 1 }).map((_, i) => (
              <button
                key={i}
                className={`home-services__carousel-dot${svcIndex === i ? " home-services__carousel-dot--active" : ""}`}
                onClick={() => setSvcIndex(i)}
                aria-label={`Go to service ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════ PORTFOLIO ═══════════ */}
      <section className="home-portfolio" ref={portRef}>
        <div className="container">
          <div className={`home-portfolio__header fade-in ${portInView ? "visible" : ""}`}>
            <div>
              <p className="section-label">Recent Work</p>
              <h2 className="section-title">Featured <span>Projects</span></h2>
              <p style={{ color: "var(--color-text-muted)", maxWidth: 560, marginTop: 8 }}>
                From mining civils to water infrastructure to industrial construction — our portfolio reflects quality, precision, and trust on every project.
              </p>
            </div>
            <div className="home-portfolio__controls">
              <div className="home-portfolio__filters-row">
                {filters.map(f => (
                  <button
                    key={f}
                    className={`port-filter${activeFilter === f ? " port-filter--active" : ""}`}
                    onClick={() => setActiveFilter(f)}
                  >
                    {f}
                  </button>
                ))}
                <Link to="/portfolio" className="btn-primary">All Projects <FiArrowRight /></Link>
              </div>
            </div>
          </div>
          <div className="home-portfolio__grid">
            {filteredPort.map((p, i) => (
              <div
                key={`${activeFilter}-${i}`}
                className={`port-card fade-in ${portInView ? "visible" : ""}`}
                style={{ transitionDelay: `${i * 0.07}s` }}
              >
                <div className="port-card__img-wrap">
                  <img src={p.src} alt={p.title} loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                  <div className="port-card__overlay">
                    <div className="port-card__cats">{p.cats.map(c => <span key={c}>{c}</span>)}</div>
                    <h4 className="port-card__title">{p.title}</h4>
                    <p className="port-card__desc">{p.desc}</p>
                    <Link to="/projects" className="port-card__link"><FiArrowRight size={16} /></Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={`home-portfolio__stat fade-in ${portInView ? "visible" : ""}`}>
            <span className="home-portfolio__stat-num">140<sup>+</sup></span>
            <span className="home-portfolio__stat-label">Completed Projects</span>
          </div>
        </div>
      </section>

      {/* ═══════════ TESTIMONIALS ═══════════ */}
      <section className="home-testi" ref={testiRef} style={{ backgroundImage: `url(${ctaBg})` }}>
        <div className="home-testi__overlay" />
        <div className="container home-testi__inner">
          <div className={`home-testi__head fade-in ${testiInView ? "visible" : ""}`}>
            <p className="section-label" style={{ color: "rgba(255,255,255,0.55)" }}>What Our Clients Say</p>
            <h2 className="section-title" style={{ color: "#fff" }}>Testimonials</h2>
            <p style={{ color: "rgba(255,255,255,0.65)", maxWidth: 520, marginTop: 8 }}>
              Genuine feedback from real clients — sharing their experiences and the trust built through every detail of every project.
            </p>
          </div>
          <div className="home-testi__grid">
            {testis.map((t, i) => (
              <div
                key={i}
                className={`testi-card fade-in ${testiInView ? "visible" : ""}`}
                style={{ transitionDelay: `${i * 0.12}s` }}
              >
                <div className="testi-card__stars">
                  {[...Array(5)].map((_, j) => <FiStar key={j} size={14} />)}
                </div>
                <p className="testi-card__body">"{t.body}"</p>
                <div className="testi-card__author">
                  <div className="testi-card__avatar">{t.name.split(" ").map(n => n[0]).join("").slice(0, 2)}</div>
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={`home-testi__footer fade-in ${testiInView ? "visible" : ""}`}>
            <Link to="/about" className="btn-hero-outline">View All Reviews <FiArrowRight /></Link>
          </div>
        </div>
      </section>

      {/* ═══════════ BLOG ═══════════ */}
      <section className="home-blog" ref={blogRef}>
        <div className="container">
          <div className={`home-blog__header fade-in ${blogInView ? "visible" : ""}`}>
            <div>
              <p className="section-label">Latest News</p>
              <h2 className="section-title">Construction News<br />&amp; <span>Insights</span></h2>
            </div>
            <Link to="/about" className="btn-outline">All Articles <FiArrowRight /></Link>
          </div>
          <div className="home-blog__grid">
            {blogPosts.map((post, i) => (
              <div
                key={i}
                className={`blog-card fade-in ${blogInView ? "visible" : ""}`}
                style={{ transitionDelay: `${i * 0.12}s` }}
              >
                <div className="blog-card__img-wrap">
                  <img src={post.img} alt={post.title} loading="lazy" draggable="false" onDragStart={e => e.preventDefault()} onContextMenu={e => e.preventDefault()} />
                  <div className="blog-card__date-stamp">
                    <span className="blog-card__date-day">{post.day}</span>
                    <span className="blog-card__date-rest">{post.month} {post.year}</span>
                  </div>
                </div>
                <div className="blog-card__body">
                  <span className="blog-card__cat">{post.cat}</span>
                  <h3 className="blog-card__title">{post.title}</h3>
                  <p className="blog-card__desc">{post.desc}</p>
                  <Link to="/about" className="blog-card__link">Read More <FiArrowRight size={14} /></Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════ FOOTER CTA STRIP ═══════════ */}
      <section className="home-footer-cta">
        <div className="container">
          <div className="home-footer-cta__inner">
            <div>
              <p className="section-label" style={{ color: "rgba(255,255,255,0.55)" }}>Call To Action</p>
              <h2 className="home-footer-cta__title">Have any project in<br /><span>your mind?</span></h2>
            </div>
            <div className="home-footer-cta__contacts">
              <div className="home-footer-cta__contact">
                <div className="home-footer-cta__icon"><FiMail size={22} /></div>
                <div>
                  <span>Mail Us Anytime</span>
                  <a href="mailto:sales@bakwenakit.co.za">sales@bakwenakit.co.za</a>
                </div>
              </div>
              <div className="home-footer-cta__contact">
                <div className="home-footer-cta__icon"><FiPhone size={22} /></div>
                <div>
                  <span>Call Us 24/7</span>
                  <a href="tel:+27120041000">+27 (12) 004-1000</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}